const CheckSupportEmail = (mail) => {
    if (!mail || mail == '') return false;
    // Expressão regular para verificar o formato do email
    const regex = /^suporte\.[a-zA-Z0-9]+@atendimentowhats\.com\.br$/;
    const regex2 = /^suporte\.[a-zA-Z0-9]+@conexadigital\.com\.br$/;
    return regex.test(mail) || regex2.test(mail) ? true : false;
}

export default CheckSupportEmail;